/**
 * CLIENT-SIDE SUPABASE INSTANCE
 * * USE CASE: Inside 'use client' components and event handlers (e.g., login forms, 
 * button clicks, real-time subscriptions).
 * * WHY: This uses the browser's fetch API and is optimized for user-driven actions.
 * It relies on the browser's cookies and is subject to Row Level Security (RLS).
 */

import { createBrowserClient } from "@supabase/ssr";

export const supabase = createBrowserClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY!
);

export async function signUpWithEmail(email: string, password: string, metadata: { firstName: string, lastName: string }) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        emailRedirectTo: `${window.location.origin}/auth/callback`,
        first_name: metadata.firstName,
        last_name: metadata.lastName,
      },
    },
  });
  return { data, error };
}

export async function signInWithEmail(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  return { data, error };
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) {
    throw error;
  }
}
